import { render, staticRenderFns } from "./ConfiguracionComponent.vue?vue&type=template&id=4375bb5d&scoped=true&"
import script from "./ConfiguracionComponent.vue?vue&type=script&lang=ts&"
export * from "./ConfiguracionComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ConfiguracionComponent.vue?vue&type=style&index=0&id=4375bb5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4375bb5d",
  null
  
)

export default component.exports